import React from "react";
import { FormattedMessage } from "gatsby-plugin-intl";

function Plan_Express_Approve() {
    return (
        <div>
            <div className="font-bold pb-0 md:pb-4">
                <a
                    className="md:text-xl text-white rounded-full bg-blue-800 px-6 py-2"
                    role="button"
                >
                    <FormattedMessage id="softpos.plan.kyc" defaultMessage="特快批核" />
                </a>
                <p className="md:text-2xl p-4 text-blue-800">
                    <FormattedMessage id="softpos.plan.couple_day" defaultMessage="提交文件後，2 個工作天內†" />
                </p>
            </div>
        </div>
    );
}

export default Plan_Express_Approve;